/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import { AnimatePresence, motion } from "framer-motion";
import { observer, inject } from "mobx-react";
import CloseOneIcon from '../svg/CloseOneIcon';
import Trash from '../svg/Trash';
import ClearCartModal from '../modals/ClearCartModal';
import MiniCartProduct from './MiniCartProduct';
import MiniCartTotals from './MiniCartTotals';

const MiniCartContent = inject('studioStore')(observer(({ toggleCart, clearCart, productCount, cartItems, isOpen, studioStore }) => {
  const tg = useTranslations('General');
  const t = useTranslations('Cart');
  const [showClearCartModal, setShowClearCartModal] = useState(false);

  const container = studioStore?.cart?.container;
  const cartBackgroundColor = studioStore?.cart?.background_color || 'white';
  const primaryColor = studioStore?.settings?.colors?.primary_color;

  let classes = "mini-cart-content";
  const style = {
    backgroundColor: cartBackgroundColor,
  };

  if (container === "stamp") {
    classes = classes + " stamp-border";
    style.backgroundImage = `radial-gradient(8px, rgba(255, 255, 255, 0) 98%, ${cartBackgroundColor}),linear-gradient(${cartBackgroundColor} 0px, ${cartBackgroundColor} 0px)`;
    style.backgroundColor = '';
  }

  return (
    <AnimatePresence mode="wait" initial={false}>
      {isOpen && (
        <>
          <motion.div
            aria-hidden="true"
            onClick={toggleCart}
            className="fixed bottom-0 left-0 right-0 top-0 z-40 bg-[rgba(0,0,0,0.3)]"
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            exit={{
              opacity: 0,
              transition: {
                delay: 0.2,
              },
            }}
            transition={{
              duration: 0.3,
            }}
          ></motion.div>
          <motion.div
            className={`${classes} fixed left-0 top-0 h-full w-full md:w-1/2 xl:w-[35%] 2xl:w-[27%] z-50 flex flex-col`}
            style={style}
            initial={{
              opacity: 0,
              x: '-100%',
            }}
            animate={{
              x: 0,
              opacity: 1,
            }}
            exit={{
              x: '-100%',
            }}
            transition={{
              duration: 0.3,
            }}
          >
            <div className="p-2" style={{color: primaryColor}}>
              <div className="flex flex-row-reverse">
                <div className="text-center h-8">
                  <button onClick={toggleCart} title={tg('close')} data-testid="cart-close-button">
                    <CloseOneIcon size="30px" stroke={primaryColor} />
                  </button>
                </div>
              </div>
              <div className="flex -mt-4">
                <div>
                  <h4 className="text-3xl font-bold font-secondary">
                    {t('my_cart')}
                  </h4>
                  <span className="font-bold font-secondary inline-block me-4">{t('total_of')} {productCount} {t('cart_items')}</span> {cartItems.length > 0 && <button onClick={() => setShowClearCartModal(true)} title={t('clear_cart')} data-testid="clear-cart-button"><Trash size="20px" stroke={primaryColor} className="inline-block" /> <span className="inline-block font-bold font-secondary">{t('clear')}</span></button>}
                </div>
              </div>
            </div>
            <div className="mini-cart-product-list flex-1 overflow-y-auto scrollbar px-2">
              {cartItems.length > 0 ? (
                cartItems.map(item => (
                  <MiniCartProduct key={item.id} item={item} />
                ))
              ) : (
                <div className="flex items-center justify-center h-full text-gray-500 text-lg" data-testid="empty-cart">
                  {t("empty_cart")}
                </div>
              )}
            </div>
            {cartItems.length > 0 && <MiniCartTotals />}

            <ClearCartModal
              isOpen={showClearCartModal}
              onClose={() => setShowClearCartModal(false)}
              onConfirm={() => {
                setShowClearCartModal(false);
                clearCart();
              }}
              studioStore={studioStore}
            />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}));

export default MiniCartContent;
